import React from "react";
import { useFormContext } from 'react-hook-form'
import styles from './MessengersCheckbox.module.scss'
import CheckBoxInput from "../Inputs/CheckBoxInput/CheckBoxInput";
import { Lang } from "../../types/common-types";
import AccountForm from "../../types/account-form.types";
import { State } from "../../state-actions-reducers";

interface MessengersCheckboxProps {
    lang: Lang
    accountForm: AccountForm
    phoneNumber: string
}
export default function MessengersCheckbox({ lang, accountForm, phoneNumber }: MessengersCheckboxProps) {
    const { watch, setValue } = useFormContext<State>()
    const state = watch()

    return <div className={styles.messengersCheckBox}>
        <span>{accountForm.contactsMessengersTitle[lang]}</span>
        <div className={styles.messengersCheck}>
            <CheckBoxInput
                testId={'telegramCheck'}
                name={'telegramCheck'}
                label={accountForm.telegramCheck}
                lang={lang}
                onChange={() => {
                    const newTelegramCheck = !state.telegramCheck
                    setValue('telegramCheck', newTelegramCheck, { shouldDirty: true })
                    if (newTelegramCheck) {
                        const updated = state.messengers.find((e) => e.type === 'Telegram' && e.isCheck)
                            ? state.messengers.map((item) => {
                                return (item.type === 'Telegram' && item.isCheck) ? {
                                    type: "Telegram",
                                    description: "Telegram",
                                    link: `https://t.me/+${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                                    isCheck: true
                                } : item
                            }) : state.messengers.filter((m) => m.type !== 'Telegram').concat(
                                {
                                    type: "Telegram",
                                    description: "Telegram",
                                    link: `https://t.me/+${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                                    isCheck: true
                                },
                            )
                        setValue('messengers', updated as any, { shouldDirty: true })
                    } else {
                        setValue('messengers', state.messengers.filter((item) => !(item.type === "Telegram" && item.isCheck)) as any, { shouldDirty: true })
                    }
                }}
                valid={true}
                value={state.telegramCheck}
            />
            <CheckBoxInput
                testId={'whatsappCheck'}
                name={'whatsappCheck'}
                label={accountForm.whatsappCheck}
                lang={lang}
                onChange={() => {
                    const newWhatsappCheck = !state.whatsappCheck
                    setValue('whatsappCheck', newWhatsappCheck, { shouldDirty: true })
                    if (newWhatsappCheck) {
                        const updated = state.messengers.find((e) => e.type === 'WhatsApp' && e.isCheck)
                            ? state.messengers.map((item) => {
                                return (item.type === 'WhatsApp' && item.isCheck) ? {
                                    type: "WhatsApp",
                                    description: "WhatsApp",
                                    link: `https://wa.me/${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                                    isCheck: true
                                } : item
                            }) : state.messengers.concat(
                                {
                                    type: "WhatsApp",
                                    description: "WhatsApp",
                                    link: `https://wa.me/${phoneNumber ? phoneNumber?.replace(/[\D]/gim, '') : ''}`,
                                    isCheck: true
                                },
                            )
                        setValue('messengers', updated as any, { shouldDirty: true })
                    } else {
                        setValue('messengers', state.messengers.filter((item) => !(item.type === "WhatsApp" && item.isCheck)) as any, { shouldDirty: true })
                    }
                }}
                value={state.whatsappCheck}
                valid={true}
            />
        </div>
    </div>
}
